import TreasuryAccountCrud from "../components/treasury/TreasuryAccountCrud";

const TreasuryAccountsPage = () => {
  return (
    <>
      <TreasuryAccountCrud />
    </>
  );
};

export default TreasuryAccountsPage;
